import React from 'react';
export const CaseViewContext = React.createContext(null);
export const useCaseViewContext = () => React.useContext(CaseViewContext);
